<div class="mascotLoading-container">
  <ng-lottie [options]="options" width="400px" height="400px" style="background-size: cover"></ng-lottie>
</div>
